<template>
    <div class="pa-5">
        <highcharts v-if="activeClientChart" ref="chart" :options="columnChartOptions" :updateArgs="updateArgs" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import { Chart } from "highcharts-vue";
import moment from "moment";

export default {
    name: "chart-view",
    components: {
        highcharts: Chart
    },
    data() {
        return {
            updateArgs: [true, true, { duration: 500 }],
            columnChartOptions: {
                xAxis: {
                    categories: [
                        this.t("January"),
                        this.t("February"),
                        this.t("March"),
                        this.t("April"),
                        this.t("May"),
                        this.t("June"),
                        this.t("July"),
                        this.t("August"),
                        this.t("September"),
                        this.t("October"),
                        this.t("November"),
                        this.t("December")
                    ]
                },
                yAxis: {
                    title: { text: "€" }
                },
                credits: {
                    enabled: false
                },
                chart: {
                    type: "column"
                },

                title: {
                    text: null
                },
                plotOptions: {
                    column: {
                        stacking: "normal"
                    },
                    series: {
                        events: {
                            legendItemClick: function(e) {
                                e.preventDefault();
                            }
                        }
                    }
                },
                series: []
            },
            countryNames: [],
            countryColors: ["#000000", "#FF0000", "#800000", "#0D802D", "#061180", "#400000", "#9C702F", "#E88B00"]
        };
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice", "activeClientChart"])
    },
    mounted() {
        this.getColumnChartData();
    },
    watch: {
        activeClientChart: function() {
            this.getColumnChartData();
        }
    },
    methods: {
        getColumnChartData() {
            this.columnChartOptions.series = [];
            let lastDate = this.activeClientChart[this.activeClientChart.length - 1].invoice_date;
            let monthArray = [];
            for (let i = 0; i < 12; i++) {
                monthArray.unshift(
                    moment(lastDate, "YYYY-MM-DD")
                        .subtract(i, "month")
                        .format("MMMM YYYY")
                );
            }
            let totalArrivedSum = new Array(12).fill(0);
            let totalNet = new Array(12).fill(0);
            for (let i = 0; i < this.activeClientChart.length; i++) {
                let invoiceDate = moment(this.activeClientChart[i].invoice_date, "YYYY-MM-DD");
                let index = monthArray.indexOf(invoiceDate.format("MMMM YYYY"));
                if (totalArrivedSum[index]) {
                    totalArrivedSum[index] += this.activeClientChart[i].total_arrived;
                    totalNet[index] += this.activeClientChart[i].total_net;
                } else {
                    totalArrivedSum[index] = this.activeClientChart[i].total_arrived || 0;
                    totalNet[index] += this.activeClientChart[i].total_net || 0;
                }
            }
            totalArrivedSum = totalArrivedSum.map(totalArrived => Math.round(totalArrived * 100) / 100);
            totalNet = totalNet.map(totalNet => Math.round(totalNet * 100) / 100);
            let arrayLastIndex = totalArrivedSum.length - 1;
            let untilFirstRealNumber = true;
            while (untilFirstRealNumber) {
                if (totalArrivedSum[arrayLastIndex] === 0) {
                    totalArrivedSum.pop();
                    totalNet.pop();
                    arrayLastIndex--;
                } else {
                    untilFirstRealNumber = false;
                }
            }
            let arrayFirstIndex = 0;
            untilFirstRealNumber = true;
            while (untilFirstRealNumber) {
                if (totalArrivedSum[arrayFirstIndex] === 0) {
                    totalArrivedSum.shift();
                    monthArray.shift();
                    totalNet.shift();
                } else {
                    untilFirstRealNumber = false;
                }
            }

            let arrivedParam = {
                name: this.activeExportInvoice.client_name,
                data: totalArrivedSum,
                color: this.countryColors[0]
            };
            /*let sumParam = {
                name: this.t("Total sum"),
                data: totalNet,
                color: this.countryColors[1]
            };*/
            monthArray = monthArray.map(name => {
                let dateName = name.split(" ");
                return parseInt(dateName[1]) === new Date().getFullYear()
                    ? this.t(dateName[0])
                    : this.t(dateName[0]) + " " + dateName[1];
            });
            //this.columnChartOptions.series.push(sumParam);
            this.columnChartOptions.series.push(arrivedParam);
            this.columnChartOptions.xAxis.categories = monthArray;
        }
    }
};
</script>

<style scoped></style>
